/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .actions-container[_ngcontent-%COMP%]{display:flex;align-items:center;flex-direction:row-reverse;margin:0 -3px}[_nghost-%COMP%]   .actions-container[_ngcontent-%COMP%]   .action[_ngcontent-%COMP%]{margin:0 3px;width:24px;height:24px;border:1px solid #dce6f1;border-radius:50%;display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]   .actions-container[_ngcontent-%COMP%]   .action.delete[_ngcontent-%COMP%]{color:#f13d36}"];
export { styles as styles };
